import type { CreateHolder, HolderModel, UpdateHolder } from '@/types/tool.types';
import { apiClient } from './client';

export const holdersApi = {
  /** GET /holders - list all holders. */
  getAll: async (): Promise<HolderModel[]> => {
    const { data } = await apiClient.get<HolderModel[]>('/holders');
    return data;
  },

  /** POST /holders - create a new holder. */
  create: async (body: CreateHolder): Promise<{ uid: string }> => {
    const { data } = await apiClient.post<{ uid: string }>('/holders', body);
    return data;
  },

  /** PUT /holders/{holder_id} - update a holder. */
  update: async (holderId: string, body: UpdateHolder): Promise<HolderModel> => {
    const { data } = await apiClient.put<HolderModel>(`/holders/${holderId}`, body);
    return data;
  },

  /** DELETE /holders/{holder_id} - delete a holder. */
  delete: async (holderId: string): Promise<void> => {
    await apiClient.delete(`/holders/${holderId}`);
  },
};
